var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentMngEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#EEF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5142 12.8203H29.4886C18.8677 12.8203 10.2578 21.4302 10.2578 32.0511V67.9485C10.2578 78.5694 18.8677 87.1793 29.4886 87.1793H70.5142C81.1351 87.1793 89.745 78.5694 89.745 67.9485V32.0511C89.745 21.4302 81.1351 12.8203 70.5142 12.8203Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0508 29.4868C32.0508 26.9227 33.9739 25.6406 36.538 25.6406H57.6918L67.9482 35.897V70.5124C67.9482 73.0765 66.0251 74.3586 63.461 74.3586H36.538C33.9739 74.3586 32.0508 73.0765 32.0508 70.5124V29.4868Z",
    fill: "#4F7CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6914 25.6406V35.897H67.9478",
    fill: "#7FA3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0009 55.1268C54.2492 55.1268 57.6932 51.6828 57.6932 47.4345C57.6932 43.1862 54.2492 39.7422 50.0009 39.7422C45.7526 39.7422 42.3086 43.1862 42.3086 47.4345C42.3086 51.6828 45.7526 55.1268 50.0009 55.1268Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7422 64.1041C39.7422 58.3348 44.2294 53.8477 49.9986 53.8477C55.7678 53.8477 60.255 58.3348 60.255 64.1041V65.3861H39.7422V64.1041Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0234 69.2266H58.9722",
    stroke: "#C9D7FF",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6431 79.4894C81.3076 79.4894 85.8995 74.8974 85.8995 69.233C85.8995 63.5685 81.3076 58.9766 75.6431 58.9766C69.9787 58.9766 65.3867 63.5685 65.3867 69.233C65.3867 74.8974 69.9787 79.4894 75.6431 79.4894Z",
    fill: "#F4F6FB",
    stroke: "#D9DFEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6399 74.358C78.4722 74.358 80.7681 72.062 80.7681 69.2298C80.7681 66.3975 78.4722 64.1016 75.6399 64.1016C72.8077 64.1016 70.5117 66.3975 70.5117 69.2298C70.5117 72.062 72.8077 74.358 75.6399 74.358Z",
    stroke: "#6B7895"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 66.25L78.75 72.5",
    stroke: "#6B7895",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentMngEmptyState);
export default __webpack_public_path__ + "static/media/document_mng_empty_state.0beaec6cb766aada13834e3f94ac99e0.svg";
export { ForwardRef as ReactComponent };